import React from "react";
import Field from "containers/Field";
import { FormLayout } from "playground/cms/Form";
import { FieldMappingRenderer } from "./FieldMapping";
import SyncTasks from "playground/cms/views/SyncTasks";

export function SyncTasksForm() {
    return (
        <FormLayout.Fieldset pad>
            <Field
                id={"integration"}
                label={"Integracja"}
                fieldType={"select"}
                source={"api:cms.integrations"}
            />
            <Field
                id={"resource_type"}
                fieldType={"select"}
                source={"schema:entries.types"}
                label={"Typ wpisu"}
            />
            <Field
                id={"background_task"}
                fieldType={"checkbox"}
                label={"Uruchamianie w tle"}
            />
            <FormLayout.Section name={"Mapowanie"}>
                <Field
                    id={"field_mapping"}
                    fieldType={"collection"}
                    CollectionRenderer={FieldMappingRenderer}
                />
            </FormLayout.Section>
            <Field id={"active"} fieldType={"checkbox"} label={"Aktywne"} />
        </FormLayout.Fieldset>
    );
}

SyncTasksForm.propTypes = {};

SyncTasksForm.defaultProps = {};

export default SyncTasksForm;
